<template>
    <div class="modal fade" id="remove-day-modal" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span>{{transEdit('therapist-remove-day')}} <span id="remove-day-modal-date"></span></span>
                        <span class="hidden" id="remove-day-modal-date-hidden"></span>
                        <span class="hidden" id="remove-day-modal-therapist-hidden"></span>
                        <span class="hidden" id="remove-day-modal-location-hidden"></span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal">
                        <span><b>x</b></span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input class="form-check-input" type="checkbox"
                            id="remove-day-modal-remove-bookings-checkbox">
                            {{transEdit('therapist-remove-day-unbook')}}
                        </label>
                    </div>
                    <br>
                    <div>
                        <label for="message">{{ transEdit('Valfritt meddelande till kund')}}</label>
                        <textarea name="message" class="form-control" v-model="message"></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger"
                            v-on:click="removeDay()"><i class="fa fa-trash"></i> {{transEdit('remove')}}</button>
                    <button class="btn btn-dark"
                            data-dismiss="modal"><i class="fa fa-ban"></i>  {{transEdit('cancel')}}</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "therapist-dash-modal-remove-day",
        props: ['route_delete_day'],
        data() {
            return {
                message: '',
            }
        },
        methods: {
            removeDay: function () {
                let self = this;
                let thisModal = $("#remove-day-modal");
                let deleteDate = $("#remove-day-modal-date-hidden").text();
                let deleteTherapist = $("#remove-day-modal-therapist-hidden").text();
                let deleteLocation = $("#remove-day-modal-location-hidden").text();
                let deleteExistingBookings = false;

                let deleteExistingBookingsCheckbox = $("#remove-day-modal-remove-bookings-checkbox");
                deleteExistingBookings = deleteExistingBookingsCheckbox.is(':checked');

                axios.delete(this.$portalUrl(self.route_delete_day), {
                    data: {
                        date: deleteDate,
                        therapist: deleteTherapist,
                        deleteExistingBookings: deleteExistingBookings,
                        location: deleteLocation,
                        message: this.message,
                    }
                })
                .then(function (response) {
                    self.$emit('refresh');
                })
                .catch(function (error) {
                });

                thisModal.modal('toggle');
            }
        }
    }
</script>

<style scoped>

</style>
